import React from 'react'
import { useTranslation } from 'react-i18next'
import { Chip, ChipProps } from '@mui/material'
import { OrderPayment } from '@/core/models/meeting-link-order.model'

interface OrderPaymentBadgeProps {
  payment?: OrderPayment
  requiresPayment?: boolean
  paymentCompleted?: boolean
}

export const OrderPaymentBadge: React.FC<OrderPaymentBadgeProps> = ({ payment, requiresPayment, paymentCompleted }) => {
  const { t } = useTranslation()

  if (!requiresPayment) {
    return null
  }

  const isPaid = paymentCompleted || payment?.paid

  const chipProps: ChipProps = isPaid
    ? { color: 'success', label: t('page.meetingLink.ordersTable.paymentStatus.paid') }
    : { color: 'warning', label: t('page.meetingLink.ordersTable.paymentStatus.pending') }

  return <Chip size="small" {...chipProps} />
}

export default OrderPaymentBadge
